import React from 'react';
import Helmet from "react-helmet";
import {Card, Row, Col} from 'react-bootstrap';
import { Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import speaker4 from '../../assets/images/contents/speaker4.jpg';

export const ProfessorDrrerpolHeriKuswanto = () => (
  <div>
    <Helmet>
      <title>The 6th International Conference on Soft Computing in Data Science 2021 (SCDS2021) - Keynote Speaker</title>
    </Helmet>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link to="/scds2021/home">Home</Link></li>
        <li class="breadcrumb-item active" aria-current="page">ProfessorDrrerpolHeriKuswanto</li>
      </ol>
    </nav>

    <Container> 
      <Row className="justify-content-md-center">  
        <Col md="auto">
          <Card>
            <Card.Img width="100px" height="220px" src={speaker4} alt="speaker image" /> 
          </Card>             
        </Col>
      </Row>
    </Container>

    <p style={{textAlign:'center'}}>
      <b>Professor Dr.rer.pol. Heri Kuswanto</b>
    </p>

    <p style={{textAlign:'center'}}>
      Institut Teknologi Sepuluh Nopember, Surabaya, Indonesia
    </p>

    <br/>

    <h4 style={{textAlign:'center'}}>Challenges in Weather and Climate Research: How can we benefit from open data source?</h4>

    <p style={{ textAlign:'justify'}}><b>Abstract</b><br/>
      It is not always easy to carry out research in weather and climate modelling due to the data constraints (data availability, data quality, 
      etc.). Furthermore, scientists in developing countries also encounter the problem of access to the observation dataset from the officials, 
      where the data are considered as an asset which should not be easily shared to the public. Open data source offers solutions to the problem. 
      However, in most cases the data cannot be directly analyzed and need to be pre-processed to generate insight from it. This talk presents 
      application of pre-processing and statistical methods applied to climate open data source e.g. data assimilation, downscaling, bias correction 
      as well as machine learning. The methods have been successfully applied to various cases in Indonesia such as extreme characterization, drought
      prediction, impact analysis and many others.
    </p>

    <p style={{ textAlign:'justify'}}><b>Biography</b><br/>
      Prof. Heri Kuswanto is a professor in computational statistics. He is currently a permanent lecturer at the Department of Statistics, Faculty of 
      Science and Data Analytics – Institut Teknologi Sepuluh Nopember (ITS) Indonesia. He is also an active researcher at the Center for Disaster 
      Mitigation and Climate Change – ITS. Prof. Kuswanto obtained his PhD from the Institute of Statistics- Leibniz Hannover University, Germany in 
      2009, and worked as Postdoctoral Research Associate in Laval University Canada in 2010. Since then, he has been working a lot on weather and climate 
      analysis using statistical methods and machine learning. Prof. Kuswanto also works in econometrics and Bayesian fields.
    </p>

    <p>Click this <a href = "https://geoengineering.environment.harvard.edu/people/heri-kuswanto/" target="_blank" rel="noreferrer">link</a> to see his further detail bio. <br/>
    </p>

  </div>
)